import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SimplePresentation, SimplePresentationRunner} from "../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../BenjiKIV";
import {BenjiKIVBoostedOverlayScatterRunner} from "../presentationrunners/scatter/BenjiKIVBoostedOverlayScatterRunner";
import {BenjiKIVNormalSpinRunner} from "../presentationrunners/general/BenjiKIVNormalSpinRunner";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class BenjiKIVNormalBetPresentation implements FlowStatePresentation {

    private readonly _presentations: SimplePresentation[];
    private _flowStateController: FlowStateController;

    constructor() {
        this._presentations = [
            new BenjiKIVNormalSpinRunner(),
            BenjiKIV.normalBoostedOverlayRunner = new BenjiKIVBoostedOverlayScatterRunner()
        ]
    }

    public start(flowStateController: FlowStateController): void {
        // #260
        BenjiKIV.xBetView.hasBetPlaced = true;

        BenjiKIV.xBetView.enableButtons(false);
        this._flowStateController = flowStateController;

        // #5
        BenjiKIV.individualWin.stop();
        BenjiKIV.winWays.hideToggleWinWays();

        BenjiKIV.multiplierCountUp.hideAllMultipliers();

        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }

    public complete(): void {
        this._flowStateController.finish();
    }
}